import React, { PropTypes } from 'react'
import { connect } from 'react-redux'
import { Grid, Row, Col, Form, Button, FormGroup, ControlLabel, FormControl } from 'react-bootstrap'
import { consts, Translate, components, utils, Actions as actions, Form as CoreForm } from 'unity-core'
const { Routes } = consts
const { getEnv } = utils
const { AlertPanel, Loader, NavLink } = components
const { FormGroupWrapper, ModalWrapper } = CoreForm
import { bindActionCreators } from 'redux'
import Forgot from 'components/Forgot'
import DOMPurify from 'dompurify'

const propTypes = {
  redirectRoute: PropTypes.string,
  isAuthenticating: PropTypes.bool,
  err: PropTypes.object,
  notice: PropTypes.object,
  strings: PropTypes.object.isRequired,
  login: PropTypes.func.isRequired,
  clearErr: PropTypes.func.isRequired,
  // getAppNotice: PropTypes.func.isRequired
}
const defaultProps = {
  isAuthenticating: false,
  redirectRoute: `/${Routes.HOME}`,
  err: null,
  notice: {}
}

export class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userName: '',
      password: ''
    }
  }

  //this is to make sure we are getting imgs from correct folder so html generated by Word would work
  setDOMHook() {
    DOMPurify.removeHook('afterSanitizeAttributes')
    DOMPurify.addHook('afterSanitizeAttributes', (node) => {
      if (node.nodeName && node.nodeName.toLowerCase() === 'img') {
        if (node.hasAttribute('src') && node.getAttribute('src').indexOf('://') === -1) {
          node.setAttribute('src', 'releaseNotes/' + this.props.lang.value + '/' + node.getAttribute('src'))
        }
      }
    });
  }

  removeDOMHook() {
    DOMPurify.removeHook('afterSanitizeAttributes')
  }

  componentDidMount() {
    this.setDOMHook()
    this.props.getAppNotice()
  }

  componentWillMount() {
    this.props.clearErr()
  }

  componentWillUnmount() {
    this.removeDOMHook()
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang.value != this.props.lang.value) {
      this.setDOMHook()
      this.props.getAppNotice()
    }
  }

  onLogin = (e) => {
    e.preventDefault();
    const { userName, password } = this.state
    const { redirectRoute } = this.props
    this.props.login(userName, password, redirectRoute);
  }

  saveUserName = (e) => {
    this.setState({
      ...this.state,
      userName: e.target.value
    })
  }

  savePassword = (e) => {
    this.setState({
      ...this.state,
      password: e.target.value
    })
  }

  dismissAlert = () => {
    this.props.clearErr()
  }

  getErrorMessage = (error) => {
    const { strings } = this.props
    if (!error) {
      return ''
    }
    if (error.response) { //API EXCEPTION
      return `${error.response.status} - ${error.message} - ${strings.Login.apiResponseErrors[error.response.status]}`
    }
    if (error.message) {  //TIMEOUT EXCEPTION
      return strings[error.message] || error.message
    }
    return error.toString()
  }

  render() {
    const { err, strings, notice } = this.props
    let errorMessage = this.getErrorMessage(err) //GET THE ERROR MESSAGE
    return (
      <div className="login-container">
        <Grid fluid className="slide-top-100">
          <Row>
            <Col md={4}>
              <Form horizontal className="login-form">
                <FormGroup controlId="formUsername"> {/* NAME FIELD */}
                  <ControlLabel>{strings.Login.Username}</ControlLabel>
                  <FormControl type="text" value={this.state.userName} placeholder={strings.Login.Username} onChange={this.saveUserName} />
                </FormGroup>
                <FormGroup controlId="formPassword"> {/* PASSWORD FIELD */}
                  <ControlLabel>{strings.Login.Password}</ControlLabel>
                  <FormControl type="password" value={this.state.password} placeholder={strings.Login.Password} onChange={this.savePassword} />
                </FormGroup>
                <FormGroup>
                    <AlertPanel msg={errorMessage} show={!_.isEmpty(err)} onDismiss={this.dismissAlert} />
					<a style={{ cursor: 'pointer', fontWeight: 'bold' }} href={getEnv().ForgotPasswordUrl}>{strings.ForgotPassword.link}</a>
                    <Button type="submit" className="pull-right" onClick={this.onLogin} disabled={this.props.isAuthenticating}>{strings.Login.Submit}</Button>
                    <div className="slide-top-40">
						<Loader loaded={!this.props.isAuthenticating} />
					</div>
                </FormGroup>
              </Form>
            </Col>
            <Col md={8}>
              <div>
                <br />
              </div>
              <div className="notice">
                <div className="notice-content">
                  <div className="notice-title">
                    <b>Welcome to the Unity Portal</b>
                  </div>
                  <div className="notice-body">
                    If you need help using this tool please visit the wiki here.
                    <a href="https://uwiki.opal.dnb.com" target="_blank" className="btn btn-primary btn-xs btn-with-icon">Unity Wiki <i className="glyphicon glyphicon-chevron-right" /></a>
                  </div>
                  <hr />
                  <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(notice.content) }}></div>
                </div>
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
    )
  }
}

Login.propTypes = propTypes
Login.defaultProps = defaultProps

const mapStateToProps = (state, ownProps) => ({
  redirectRoute: ownProps.location.query.redirect,
  isAuthenticating: state.user.isAuthenticating,
  notice: state.app.notice,
  lang: state.user.lang,
  err: state.user.err
});
const mapDispatchToProps = (dispatch) => ({
  login: bindActionCreators(actions.User.login, dispatch),
  clearErr: bindActionCreators(actions.User.clearErr, dispatch),
  getAppNotice: () => dispatch(actions.App.getAppNotice())
})

const decorators = _.flow([
  connect(mapStateToProps, mapDispatchToProps),
  Translate('Login', 'ForgotPassword')
]);

export default decorators(Login)
